import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Offerings = () => {
  const { t } = useLang();
  const items = t("offerings.items");
  return (
    <section id="angebote" className="relative py-32 lg:py-48 bg-[#081328]" data-testid="offerings-section">
      <div className="container-sat">
        <div className="max-w-3xl mb-16">
          <div className="overline mb-6">{t("offerings.overline")}</div>
          <h2 className="headline-xl text-4xl md:text-5xl lg:text-7xl">{t("offerings.title")}</h2>
        </div>

        <div className="space-y-px bg-white/5 rounded-2xl overflow-hidden border border-white/5" data-testid="offerings-list">
          {items.map((o, i) => (
            <div
              key={i}
              className="group relative grid md:grid-cols-12 items-center gap-6 p-8 md:p-10 bg-[#081328] hover:bg-[#0E1A30] transition cursor-pointer"
              data-testid={`offering-row-${i}`}
            >
              <div className="md:col-span-1 num-mark">{String(i + 1).padStart(2, "0")}</div>
              <div className="md:col-span-4">
                <h3 className="serif text-3xl md:text-4xl font-light">{o.t}</h3>
              </div>
              <div className="md:col-span-5 text-white/65 leading-relaxed">{o.d}</div>
              <div className="md:col-span-2 flex md:justify-end items-center gap-4">
                <span className="text-[#D4AF37] text-sm tracking-wider">{o.price}</span>
                <ArrowRight size={18} className="text-white/30 group-hover:text-[#D4AF37] group-hover:translate-x-1 transition" />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <Link to="/erstgespraech" className="btn-secondary" data-testid="offerings-cta">Kostenloses Erstgespräch <ArrowRight size={16} /></Link>
        </div>
      </div>
    </section>
  );
};

export default Offerings;
